import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';
import api from '../api';
import { SelectedCompanyContext } from '../contexts/SelectedCompanyContext';
import { AnimatedBackground } from './ui/modern';

const OnboardingLayout = () => {
  const { companyId } = useParams();
  const { selected, setSelected } = useContext(SelectedCompanyContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // if context already has selected and id matches, skip fetch
    if (selected && selected.id === parseInt(companyId)) return;
    const fetchCompany = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/companies/${companyId}`);
        setSelected(response.data);
      } catch (err) {
        setError('Failed to fetch company');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchCompany();
  }, [companyId, selected, setSelected]);

  // redirect logic based on tasks state
  useEffect(() => {
    if (!selected) return;
    const hasTasks = selected.CompanyTasks && selected.CompanyTasks.length > 0;
    if (!hasTasks && !location.pathname.endsWith('/select-systems') && !location.pathname.endsWith('/wizard')) {
      navigate(`/onboarding/${companyId}/select-systems`, { replace: true });
    }
    if (hasTasks && location.pathname.endsWith('/select-systems')) {
      navigate(`/onboarding/${companyId}`, { replace: true });
    }
  }, [selected, companyId, location.pathname, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gradient-to-br dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 flex items-center justify-center">
        <AnimatedBackground />
        <div className="relative z-10 text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <div className="text-gray-900 dark:text-white text-lg">Loading onboarding...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gradient-to-br dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 flex items-center justify-center">
        <AnimatedBackground />
        <div className="relative z-10 text-center">
          <div className="text-red-600 dark:text-red-400 text-xl font-semibold mb-2">⚠️ Error</div>
          <div className="text-gray-600 dark:text-slate-400">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
};

export default OnboardingLayout;
